import { Button } from "primereact/button";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

const StepperNavigation = ({
  onBack,
  onNext,
  canGoBack = true,
  canGoNext = true,
  nextDisabled = false,
  nextTooltip = "",
  nextTooltipKey = "",
  nextTestId,
  showNext = true
}) => {

  const nextButtonProps = {
    label: "Next",
    icon: "pi pi-arrow-right",
    iconPos: "right",
    onClick: onNext,
    disabled: nextDisabled,
    className: nextDisabled ? "disabled-btn" : "",
    "aria-label": "Next",
    ...(nextTestId ? { "data-testid": nextTestId } : {}),
    ...(nextDisabled && nextTooltip ? { "data-tooltip": nextTooltip } : {}),
    ...(nextDisabled && nextTooltipKey ? { "data-tooltip-key": nextTooltipKey } : {}),
  };

  const nextButton = <Button {...nextButtonProps} />;

  return (
    <div className="flex py-4">
      <div className="flex py-4 gap-2">

        {canGoBack && (
          <Button
            label="Back"
            severity="secondary"
            icon="pi pi-arrow-left"
            onClick={onBack}
          />
        )}

        {showNext && (
          nextDisabled ? (
            <>
              {nextTooltip && (
                <span
                  data-testid="fincobox-los-next-tooltip"
                  data-tooltip-key={nextTooltipKey || undefined}
                  className="visually-hidden"
                  aria-hidden="true"
                >
                  {nextTooltip}
                </span>
              )}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="button-tooltip">{nextTooltip}</Tooltip>}
              >
                <div>{nextButton}</div>
              </OverlayTrigger>
            </>
          ) : (
            nextButton
          )
        )}

      </div>
    </div>
  );
};

export default StepperNavigation;
